/* read more function on product pages */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".read-more").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault(); // Prevents the #more jump
      let content = this.nextElementSibling;
      if (content.classList.contains("read-more-content")) {
        content.style.display = "block";
        this.style.display = "none";
        let readLess = content.nextElementSibling;
        if (readLess && readLess.classList.contains("read-less")) {
          readLess.style.display = "inline-block";
        }
      }
    });
  });

  document.querySelectorAll(".read-less").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault(); // Prevents the #less jump
      let content = this.previousElementSibling;
      if (content.classList.contains("read-more-content")) {
        content.style.display = "none";
        this.style.display = "none";
        let readMore = content.previousElementSibling;
        if (readMore && readMore.classList.contains("read-more")) {
          readMore.style.display = "inline-block";
        }
      }
    });
  });
});